import { DeleteBtn } from "../Utility/Utility";
// ─────────────────────────────────────────────
// 2. ImageBlock — height determined by image
// ─────────────────────────────────────────────
export function ImageBlock({ item, onDelete, width, deletable = true }) {
  return (
    <div
      style={{
        position: "relative",
        width,
        borderRadius: 10,
        overflow: "hidden",
        background: "#f0f0f0",
        boxShadow: "0 2px 12px rgba(0,0,0,0.12)",
        flexShrink: 0,
        lineHeight: 0, // remove gap under img
      }}
    >
      <img
        src={item.res.url}
        alt={`image-${item.ind}`}
        style={{
          width: "100%",
          height: "auto",
          display: "block",
          objectFit: "cover",
        }}
      />
      {deletable && <DeleteBtn onDelete={onDelete} />}
    </div>
  );
}
